module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-seven2.1b9a0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-seven2.png
// module id = Z0wu
// module chunks = 0